import React from "react";
import {
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Stack,
  useDisclosure,
  Link
} from '@chakra-ui/react'
import { PopoverIcon } from './PopoverIcon'
import {Link as GatsbyLink} from 'gatsby'
// import { useStaticQuery, graphql } from "gatsby"

export const DocumentPopoverTwo = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  // const data = useStaticQuery(graphql`
  // {
  //   allSanityVisite {
  //     nodes {
  //       title
  //       slug {
  //         current
  //       }
  //       id
  //     }
  //   }
  // }
  // `)
  // const navLinks = data.allSanityVisite.nodes;
  return (
    <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose} trigger="hover" openDelay={0}>
      <PopoverTrigger>
        <Button rightIcon={<PopoverIcon isOpen={isOpen} />}>Di Cosa Mi Occupo</Button>
      </PopoverTrigger>
      <PopoverContent p="2" maxW="fit-content">
        <Stack spacing="0" alignItems="stretch">
          <Link as={GatsbyLink} to={`/nutrizione-sportiva`}  _hover={{textDecor: "none"}} >
            <Button  variant="tertiary" justifyContent="start">
              Nutrizione Sportiva
            </Button>
          </Link>
          <Link as={GatsbyLink} to={`/nutrizione-clinica`}  _hover={{textDecor: "none"}} >
            <Button  variant="tertiary" justifyContent="start">
              Nutrizione Clinica
            </Button>
          </Link>
          <Link as={GatsbyLink} to={`/educazione-alimentare`}  _hover={{textDecor: "none"}} >
            <Button  variant="tertiary" justifyContent="start">
              Educazione Alimentare
            </Button>
          </Link>
          <Link as={GatsbyLink} to={`/analisi-della-composizione-corporea`}  _hover={{textDecor: "none"}} >
            <Button  variant="tertiary" justifyContent="start">
              Analisi Composizione Corporea
            </Button>
          </Link>       
        </Stack>
      </PopoverContent>
    </Popover>
  )
}